import { diffLines } from 'diff';

export type U3203LineDiffType = 'added' | 'removed' | 'unchanged';

export interface U3203LineDiffEntry {
  type: U3203LineDiffType;
  line: string;
}

export function u3203ComputeLineDiff(before: string, after: string): U3203LineDiffEntry[] {
  const parts = diffLines(before ?? '', after ?? '');
  const entries: U3203LineDiffEntry[] = [];

  for (const part of parts) {
    const lines = part.value.split('\n');
    const trimmedLines = lines[lines.length - 1] === '' ? lines.slice(0, -1) : lines;
    const type: U3203LineDiffType = part.added ? 'added' : part.removed ? 'removed' : 'unchanged';
    for (const line of trimmedLines) {
      entries.push({ type, line });
    }
  }

  return entries;
}

export function u3203TextsDiffer(before: string | null | undefined, after: string | null | undefined): boolean {
  return (before ?? '') !== (after ?? '');
}
